const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const scripts = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "SET_CAMPAIGN_SCRIPTS":
      return { ...state, data: action.data };

    case "UPDATE_SCRIPT":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case "REMOVE_SCRIPT":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case "INSERT_SCRIPT":
      return { ...state, data: [...state.data, action.data] };

    case "SET_CAMPAIGN_SCRIPTS_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_CAMPAIGN_SCRIPTS_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default scripts;
